import React from "react";
import { useTranslation } from "react-i18next";
import Stats from "./components/Stats";
import { Col, Row } from "react-bootstrap";
import Countries from "./components/Countries";
import Traffic from "./components/Traffic";
import Devices from "./components/Devices";
import Sessions from "./components/Sessions";

const Home = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Stats mode={props.profile.mode} t={t} />
      <Row>
        <Col lg="4" className="my-2">
          <Countries mode={props.profile.mode} t={t} />
        </Col>
        <Col lg="8" className="my-2">
          <Traffic mode={props.profile.mode} t={t} />
        </Col>
        <Col lg="6" className="my-2">
          <Sessions mode={props.profile.mode} t={t} />
        </Col>
        <Col lg="6" className="my-2">
          <Devices mode={props.profile.mode} t={t} />
        </Col>
      </Row>
    </>
  );
};

export default Home;
